import * as S from './index.style'
import { DadosDetalhamentoProjeto } from 'models/Viabilidade/DadosDetalhamentoProjeto'
import Tipologias from './Tipologias'
import LoteamentoComercial from './LoteamentoComercial'
import ComponentesProjeto from './ComponentesProjeto'
import Muros from './Muros'
import Divider from '@material-ui/core/Divider'
import { DadosTipologia } from 'models/Viabilidade/Tipologia'
import { DadosLoteamentoComercial } from 'models/Viabilidade/DadosLoteamentoComercial'
import { DadosComponentesProjeto } from 'models/Viabilidade/DadosComponentesProjeto'
import { DadosMuros } from 'models/Viabilidade/DadosMuros'
import { TipoProjetoEnum } from 'models/Viabilidade/Enum/TipoProjetoEnum'

const CartaoDadosDetalhamentoProjeto: React.FC<{
  tipoProjeto: string
  dadosDetalhamentoProjeto: DadosDetalhamentoProjeto
  dadosDetalhamentoProjetoHandler: (novoValor: DadosDetalhamentoProjeto) => void
}> = ({ tipoProjeto, dadosDetalhamentoProjeto, dadosDetalhamentoProjetoHandler }) => {
  const dadosTipologiaHandler = (novoDadosTipologia: DadosTipologia[]) => {
    const novoValor = { ...dadosDetalhamentoProjeto }
    novoValor.tipologias = novoDadosTipologia

    dadosDetalhamentoProjetoHandler(novoValor)
  }
  const dadosLoteamentoComercialHandler = (novoDadosLoteamentoComercial: DadosLoteamentoComercial) => {
    const novoValor = { ...dadosDetalhamentoProjeto }
    novoValor.loteamentoComercial = novoDadosLoteamentoComercial
    dadosDetalhamentoProjetoHandler(novoValor)
  }
  const dadosComponenteProjetoHandler = (novoDadosComponentesProjeto: DadosComponentesProjeto) => {
    const novoValor = { ...dadosDetalhamentoProjeto }
    novoValor.componentesProjeto = novoDadosComponentesProjeto
    dadosDetalhamentoProjetoHandler(novoValor)
  }
  const dadosMurosHandler = (novoDadosComponentesProjeto: DadosMuros) => {
    const novoValor = { ...dadosDetalhamentoProjeto }
    novoValor.muros = novoDadosComponentesProjeto
    dadosDetalhamentoProjetoHandler(novoValor)
  }

  return (
    <S.Wrapper>
      <Tipologias dadosDetalhamentoProjeto={dadosDetalhamentoProjeto} dadosTipologiaHandler={dadosTipologiaHandler}></Tipologias>
      <LoteamentoComercial
        dadosLoteamentoComercial={dadosDetalhamentoProjeto.loteamentoComercial}
        dadosLoteamentoComercialHandler={dadosLoteamentoComercialHandler}
      ></LoteamentoComercial>
      <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '32px' }} />
      {tipoProjeto !== '' && (
        <>
          {tipoProjeto === TipoProjetoEnum.CondominioIncorporacao && (
            <>
              <ComponentesProjeto
                dadosComponentesProjeto={dadosDetalhamentoProjeto.componentesProjeto}
                dadosComponentesProjetoHandler={dadosComponenteProjetoHandler}
              ></ComponentesProjeto>
              <Divider orientation="horizontal" color="#D9DDDB" style={{ marginBottom: '40px', marginTop: '32px' }} />
            </>
          )}
          <Muros tipoProjeto={tipoProjeto} dadosMuros={dadosDetalhamentoProjeto.muros} dadosMurosHandler={dadosMurosHandler}></Muros>
        </>
      )}
    </S.Wrapper>
  )
}

export default CartaoDadosDetalhamentoProjeto
